/* RESPONSIBLE TEAM: team-inbox */
import ApplicationAdapter from '../application';

export default class RealtimeDashboardSettingsAdapter extends ApplicationAdapter {
  pathForType() {
    return 'monitoring/visible_fields';
  }
}
